@if (option !== null) {
  <div class="option-container">
    <a
      class="nav-link fw-medium"
      [routerLink]="navigateIfOutOfRoute(option)"
      [class]="{
        active: active,
      }"
    >
      <span
        class="left-nav-icon"
        [tooltip]="option.text"
        [adaptivePosition]="false"
        placement="right"
        container="body"
        [isDisabled]="sideNavOpen()"
      >
        <ng-content select="[icon]"></ng-content>
      </span>
      {{ option.text }}
      @if (subnav.children.length !== 0) {
        <i class="modus-icons carat down" aria-hidden="true">expand_more</i
        ><i class="modus-icons carat up" aria-hidden="true">expand_less</i>
      }
    </a>
    <div #subnav><ng-content select="[subnav]"></ng-content></div>
  </div>
}
